(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('ImportConstructelDeleteController',ImportConstructelDeleteController);

    ImportConstructelDeleteController.$inject = ['$uibModalInstance', 'entity', 'ImportConstructel'];

    function ImportConstructelDeleteController($uibModalInstance, entity, ImportConstructel) {
        var vm = this;

        vm.importConstructel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ImportConstructel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
